module.exports = __webpack_public_path__ + "img/logo-ig.23df76c1.png";